export default "__VITE_ASSET__9e615dc1__"